(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/utils/bitwise/assets/javascripts/bitwise.js') >= 0) return;  svs.modules.push('/components/utils/bitwise/assets/javascripts/bitwise.js'); var svs = svs || {};

(function(svs) {
  'use strict';

  svs.utils = svs.utils || {};
  svs.utils.bitwise = svs.utils.bitwise || {};

  svs.utils.bitwise.PopCnt = function(n) {
    n >>>= 0;
    var popcnt;
    for (popcnt = 0; n; n &= n - 1) {
      popcnt++;
    }
    return popcnt;
  };
})(svs);

 })(window);